import SideTool from "@/global/components/side-tool";
import './index.less';
import { Button, Modal, Table, Tooltip } from "antd";
import classnames from "classnames";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import { Sensor } from "@/global/interface/device/sensor";
import AddSensorModal from "./add-modal";
import TnMessage from "@/global/components/message";
import { ReactComponent as PlaceSvg } from '@/global/icons/table/place.svg';
import { ReactComponent as CheckSvg } from '@/global/icons/table/check.svg';
import { ReactComponent as CheckedSvg } from '@/global/icons/table/checked.svg';
import EditSensorModal from "./edit-modal";
import TnModal from "@/global/components/base-modal";
import { getSensors, deleteSensor, deleteSensors, createSensor, createSensors, updateSensor, deleteSensorByPrimitiveUuid } from "@/api/device/sensor";
import { SideContext } from "@/App";
import { SideStatus } from "@/global/store/side-store";
import { graphicStore } from "@/global/store/graphic-store";
import { DEVICEBASE_SINGAL } from "@/passets/devicebase-engine/enums/devicebase-singal";
import { BlockT, BoxT, CircleT, ModelBase, Point } from "pytha";
import { createPrimitiveMulti, deletePrimitivesInGraphic } from "@/api/geometry/primitive";
import { DEVICE_SUB_CONTROL } from "@/passets/devicebase-engine/enums/device-sub-controls";
import { Vector3 } from "three";
import { SENSOR_MODEL_TYPE, SENSOR_TYPE } from "@/enums/sensor-type";
import { FluviographT } from "@/passets/devicebase-engine/models/FluviographT";
import { MonitorT } from "@/passets/devicebase-engine/models/MonitorT";
import { AnemoclinographT } from "@/passets/devicebase-engine/models/AnemoclinographT";
import { FluviographTComponentJsonObject } from "@/passets/devicebase-engine/components/fluviograph";
import { AnemoclinographTComponentJsonObject } from "@/passets/devicebase-engine/components/anemoclinograph";
import LinkGlobalSensorModal from "./link-modal";
import { GlobalSensor } from "@/global/interface/lib-device/global-sensor";
import { createProjectGSensors, deleteProjectGSensor, getProjectSensors } from "@/api/project-device/project-sensor";
import { RsProjectGlobalSensor } from "@/global/interface/project-device/project-sensor";
import axios from "axios";
import { getSpecialPrimitiveLayerUuid } from "@/global/utils/layer-utils";
import { LayerType } from "@/enums/layer-type";
import { findComponentByType } from "@/api/archi/conponent";
import { Component } from "@/global/interface/archi/component";

interface Iprops {
    sensorType: number
}

export default function SensorContainer(props: Iprops) {
    const { projectId } = useParams();
    const location = useLocation();
    const navigate = useNavigate();
    const sideContext = useContext<SideStatus>(SideContext);
    const [loading, setLoading] = useState<boolean>(false); // loading
    const [activeRow, setActiveRow] = useState<GlobalSensor>(null); // 表格选中行
    const [hoverRow, setHoverRow] = useState<GlobalSensor>(null); // 鼠标悬浮行
    const [sensors, setSensors] = useState<GlobalSensor[]>([]); // 传感器列表
    const [showAddModal, setShowAddModal] = useState<boolean>(false); // 打开添加弹窗
    const [addLoading, setAddLoading] = useState<boolean>(false); // 添加弹窗的loading
    const [muitiple, setMuitiple] = useState<boolean>(false); // 是否开启多选
    const [selectedRows, setSelectedRows] = useState<GlobalSensor[]>([]); // 多选选中的列

    const [placeRow, setPlaceRow] = useState<GlobalSensor>(); // 正在布置的传感器
    // 监听二级控制器结束和按下ESC
    useEffect(() => {
        if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
        // graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.getSignal(DEVICEBASE_SINGAL.onAssembleDeviceFinish).add(onAssembleDeviceFinish);
        graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.signals.onOpeCommandControlEnd.add(onOpeCommandControlEnd);
        graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.signals.onProcessEscape.add(onOpeCommandControlEnd);

        return () => {
            if (!graphicStore?.extraContext?.getCurrentViewEditor()) return;
            // graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.getSignal(DEVICEBASE_SINGAL.onAssembleDeviceFinish).remove(onAssembleDeviceFinish)
            graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.signals.onOpeCommandControlEnd.remove(onOpeCommandControlEnd);
            graphicStore?.extraContext?.getCurrentViewEditor()?.listeners.signals.onProcessEscape.remove(onOpeCommandControlEnd);
        }
    }, [graphicStore?.extraContext?.getCurrentViewEditor()])

    // 初始化
    useEffect(() => {
        if (!projectId) return;
        generateData();
    }, [+projectId, props.sensorType, sideContext.needRenderSensorSide])

    // 获取传感器列表
    const generateData = () => {
        setLoading(true);

        getProjectSensors(+projectId, props.sensorType).then(res => {
            let data: GlobalSensor[] = res.data || [];
            setSensors(data);
        }).catch(err => {
            TnMessage.error("查询失败");
        }).finally(() => {
            setLoading(false);
        })
    }

    // 二级控制器执行完成的回调
    const onOpeCommandControlEnd = () => {
        setPlaceRow(null);
    }

    // 监听多选的变化
    useEffect(() => {
        if (!muitiple) {
            setSelectedRows([]);
        }
    }, [muitiple])

    // 点击工具栏添加按钮
    const onAddClick = () => {
        setShowAddModal(true);
    }

    // 点击工具栏编辑按钮
    // const onEditClick = () => {
    //     if (!activeRow) {
    //         TnMessage.warning("未选中传感器");
    //         return;
    //     }
    //     setShowEditModal(true);
    // }

    // 点击工具栏删除按钮
    const onDeleteClick = () => {
        if ((muitiple && selectedRows?.length === 0) || (!muitiple && !activeRow)) {
            TnMessage.warning("未选中传感器");
            return;
        }

        TnModal().deleteModal({
            onOk() {
                if (!muitiple) {
                    deleteProjectGSensor(+projectId, activeRow?.id).then(res => {
                        if (res.status === 200) {
                            let idx = sensors?.findIndex(item => item.id === activeRow.id);
                            sensors.splice(idx, 1);
                            setSensors([...sensors]);
                            setActiveRow(null);
                            TnMessage.success("删除成功");
                        }
                    }).catch(err => {
                        TnMessage.error("删除失败");
                    }).finally(() => {
                        Modal.destroyAll();
                    })
                } else {
                    let promiseList = [];
                    for (let item of selectedRows) {
                        promiseList.push(() => deleteProjectGSensor(+projectId, item.id));
                    }
                    axios.all(promiseList?.map(fn => fn())).then(res => {
                        let newSensors = sensors?.filter(item => !selectedRows?.some(r => r.id === item.id));
                        setSensors(newSensors);
                        setSelectedRows([]);
                        TnMessage.success("删除成功");
                    }).catch(err => {
                        TnMessage.error("删除失败");
                    }).finally(() => {
                        Modal.destroyAll();
                    })
                }
            },
            onCancel() {
                Modal.destroyAll();
            },
            closable: true
        })

    }

    // 添加传感器点击确认
    const onAddFinish = (values) => {

        if (values?.length === 0) {
            setShowAddModal(false);
            return;
        }
        let pars: RsProjectGlobalSensor[] = values?.map(item => {
            let par: RsProjectGlobalSensor = {
                projectId: +projectId,
                globalSensorId: item,
            }
            return par;
        })
        setAddLoading(true);
        createProjectGSensors(pars).then(res => {
            if (res.status === 200) {
                let newPSensors = res.data || [];
                setSensors([...sensors, ...newPSensors]);
                TnMessage.success("添加成功");
                setShowAddModal(false);
            }
        }).catch(err => {
            TnMessage.error(err?.data || "添加失败");
        }).finally(() => {
            setAddLoading(false);
        })
    }


    // 点击布置按钮
    const onPlaceClick = (row: GlobalSensor) => {
        if (!row) return;
        if (!location.pathname.match(/^\/bim\/project\/\d+\/draw\/draw-main\/?$/)) {
            navigate(`/bim/project/${projectId}/draw/draw-main`);
            TnMessage.info("正在切换至绘图区...", { duration: 1 });
            return;
        }
        setPlaceRow(row);
        let layerType;
        if (props.sensorType === SENSOR_TYPE.ANEMOCLINOGRAPH) {
            layerType = LayerType.ANEMOCLINOGRAPH;
        } else if (props.sensorType === SENSOR_TYPE.FLUVIOGRAPH) {
            layerType = LayerType.FLUVIOGRAPH;
        } else if (props.sensorType === SENSOR_TYPE.CAMERA) {
            layerType = LayerType.CAMERA;
        }

        findComponentByType(SENSOR_MODEL_TYPE[props.sensorType]).then(res => {
            let data: Component = res.data;
            let block;
            if (props.sensorType === SENSOR_TYPE.FLUVIOGRAPH) {
                let component = new FluviographT().fromJson(data);
                block = new FluviographT(new Point(component?.position?.x, component?.position?.y, component?.position?.z), [component]);
            } else if (props.sensorType === SENSOR_TYPE.ANEMOCLINOGRAPH) {
                let component = new AnemoclinographT().fromJson(data);
                block = new AnemoclinographT(new Point(component?.position?.x, component?.position?.y, component?.position?.z), [component]);
            } else {
                let component = new MonitorT().fromJson(data);
                block = new MonitorT(new Point(component?.position?.x, component?.position?.y, component?.position?.z), [component]);
            }
            block.isColorByLayer = false;
            block.extraData = {
                globalSensorId: row?.id,
            }

            getSpecialPrimitiveLayerUuid(projectId, layerType).then((layerUuid: string) => {
                graphicStore.extraContext.getCurrentViewEditor()?.listeners.signals.onOpeCommandActive.dispatch(DEVICE_SUB_CONTROL.ASSEMBLEDEVICE.name);
                block.layerUuid = layerUuid;
                graphicStore.extraContext.getCurrentViewEditor()?.listeners.getSignal(DEVICEBASE_SINGAL.onAssembleDevice)
                    .dispatch(block, new Vector3(block?.position?.x, block?.position?.y, block?.position?.z), layerUuid);
                TnMessage.info("开始布置设备...")
            });
        })

    }


    return (
        <div className="sensor-container">
            <SideTool onAddClick={onAddClick}
                // onEditClick={onEditClick}
                onDeleteClick={onDeleteClick}
                onSelectClick={() => setMuitiple(true)}
                onUnSelectClick={() => setMuitiple(false)}
            />
            <div className="table-area">
                <Table
                    rowKey="id"
                    pagination={false}
                    dataSource={sensors}
                    className='tn-monix-table'
                    rowClassName={row => classnames({
                        "monix-row-select": activeRow?.id === row.id
                    })}
                    bordered={false}
                    onRow={row => {
                        return {
                            onClick: () => setActiveRow(row),
                            onMouseEnter: () => setHoverRow(row),
                            onMouseLeave: () => setHoverRow(null),
                        }
                    }}
                    sticky
                    loading={loading}
                >
                    <Table.Column dataIndex="name" title="名称" width='25%' ellipsis
                        render={(value, row: GlobalSensor) => {
                            return (
                                <>
                                    <Tooltip title={value} placement="bottom">
                                        <div className='multi-cell'>
                                            <div className="multi-icon" onClick={(e) => {
                                                e.stopPropagation();
                                                e.preventDefault();
                                                let idx = selectedRows?.findIndex(item => item.id === row.id);
                                                if (idx === -1) {
                                                    setSelectedRows([...selectedRows, row]);
                                                } else {
                                                    selectedRows.splice(idx, 1);
                                                    setSelectedRows([...selectedRows]);
                                                }
                                            }}>
                                                {muitiple && !selectedRows?.some(item => item?.id === row?.id) && <CheckSvg />}
                                                {muitiple && selectedRows?.some(item => item?.id === row?.id) && <CheckedSvg />}
                                            </div>
                                            <div className="multi-text">{value}</div>
                                        </div>
                                    </Tooltip>
                                </>
                            )
                        }}
                    />
                    <Table.Column dataIndex="marking" title="型号" width='25%' ellipsis align="center"
                        render={(value) => {
                            return (
                                <Tooltip title={value} placement="bottom">
                                    <div className='cell'>{value}</div>
                                </Tooltip>
                            )
                        }}
                    />
                    <Table.Column dataIndex="manufacturer" title="厂商" width='20%' ellipsis align="center"
                        render={(value) => {
                            return (
                                <Tooltip title={value} placement="bottom">
                                    <div className='cell'>{value}</div>
                                </Tooltip>
                            )
                        }}
                    />
                    <Table.Column dataIndex="range" title="测量范围" width='30%' ellipsis align="right"
                        render={(value, row: GlobalSensor) => {
                            if (!!hoverRow && hoverRow?.id === row?.id && !placeRow) {
                                return (
                                    <div className="place-button" onClick={() => onPlaceClick(row)}>
                                        <div className="place-icon"><PlaceSvg /></div>
                                        <div className="place-text">布置</div>
                                    </div>
                                )
                            } else {
                                return (
                                    <Tooltip title={value} placement="bottom">
                                        <div className='cell'>{value}</div>
                                    </Tooltip>
                                )
                            }

                        }}
                    />
                </Table>
            </div>

            {showAddModal && <LinkGlobalSensorModal sensorType={props.sensorType} visible={showAddModal} setVisible={setShowAddModal}
                onFinish={onAddFinish} loading={addLoading} filterItems={sensors} />}
            {/* {showAddModal && <AddSensorModal sensorType={props.sensorType} visible={showAddModal} setVisible={setShowAddModal} onFinish={onAddFinish} loading={addLoading} />} */}
            {/* {showEditModal && <EditSensorModal sensor={activeRow} visible={showEditModal} setVisible={setShowEditModal} onFinish={onEditFinish} loading={editLoading} />} */}
        </div>
    )
}